import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/shared/services/user-services/user.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css'],
})
export class ResetPasswordComponent implements OnInit {
  resetPasswordForm!: FormGroup;

  showPassword = true;
  reEnterPassword = true;
  tokenPassword: any
  constructor(
    private formBuilder: FormBuilder,
    private readonly userAuthService: UserService,
    private route: ActivatedRoute,
    private router: Router,
    private toaster: ToastrService
  ) { }

  ngOnInit() {
    this.tokenPassword = this.route.snapshot.queryParamMap.get('token')
    this.userAuthService.checkTokenValidation(this.tokenPassword).subscribe({
      next: (res) => {
        this.resetPasswordForm.reset();
      },
      error: (error) => {
        this.toaster.error(error.error.message);
        this.router.navigateByUrl('/');
      },
      complete: () => console.log('Observable complete'),
    });

    this.resetPasswordForm = this.formBuilder.group({
      newpassword: [
        '',
        [
          Validators.required,
          Validators.pattern(
            '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&]).{8,}'
          ),
        ],
      ],
      confirmpassword: ['', Validators.required],
    });
  }

  get formControls() {
    return this.resetPasswordForm?.controls;
  }

  confirmResetPassword() {

    if (
      this.resetPasswordForm.valid &&
      this.resetPasswordForm.get('newpassword')?.value ===
      this.resetPasswordForm.get('confirmpassword')?.value
    ) {
      let payload = {
        password: this.resetPasswordForm.get('newpassword')?.value,
      };
      this.userAuthService.resetPassword(this.tokenPassword, payload).subscribe({
        next: (res) => {
          this.toaster.success(res.message);
          this.router.navigateByUrl('/');
          this.resetPasswordForm.reset();
        },
        error: (error) => {
          this.toaster.error(error.error.message);
        },
        complete: () => console.log('Observable complete'),
      });
    }
  }
}
